import styled from 'styled-components'

export const Actions = styled.div`
    padding: 10px 12px;
    display: flex;
`
